export default "__VITE_ASSET__a8e70233__"